export function formatDate(dateVal: string | undefined | null | Date | number): string {
    if (dateVal === null || dateVal === undefined) {
        return '';
    }
    else if (dateVal instanceof String) {
        try {
            return new Date(Date.parse(dateVal as string)).toLocaleDateString('en-us');
        }
        catch (e) {
            window.appInsights.trackException(e);
            return '';
        }
    }
    else if (dateVal instanceof Date) {
        return dateVal.toLocaleDateString('en-us');
    }
    else {
        try {
            return new Date(dateVal).toLocaleDateString('en-us');
        }
        catch (e) {
            window.appInsights.trackException(e);
            return '';
        }
    }
}

export function formatTime(dateVal: string | undefined | null | Date | number): string {
    if (dateVal === null || dateVal === undefined) {
        return '';
    }
    else if (dateVal instanceof String) {
        try {
            return new Date(Date.parse(dateVal as string)).toLocaleTimeString('en-us');
        }
        catch (e) {
            window.appInsights.trackException(e);
            return '';
        }
    }
    else if (dateVal instanceof Date) {
        return dateVal.toLocaleTimeString('en-us');
    }
    else {
        try {
            return new Date(dateVal).toLocaleTimeString('en-us');
        }
        catch (e) {
            window.appInsights.trackException(e);
            return '';
        }
    }
}

export function formatStringToDate(dt: Date): string {
    // FORMAT YYYY-DD-MM
    return dt.getFullYear().toString().padStart(4, '0') + '-'
    + (dt.getMonth() + 1).toString().padStart(2, '0') + '-'
    + dt.getDate().toString().padStart(2, '0');
}

export function formatDateTimeToString(dt: Date, time: string): string {
    // FORMAT YYYY-DD-MMTHH:MM:SS
    let timeparts = ['00', '00', '00'];

    if (time !== null && time !== '' && time !== undefined && time.indexOf(':') > -1) {
        timeparts = time.split(':');
    }

    return formatStringToDate(dt) + 'T' +
    timeparts[0].padStart(2, '0') + ':' +
    timeparts[1].padStart(2, '0') + ':00';
}

export function splitCamelCase(camelCased: string): string {
    return camelCased.replace(/([a-z](?=[A-Z]))/g, '$1 ');
}
